// removed by extract-text-webpack-plugin
module.exports = {"variables":"'src/styles/variables.css'","section-header-border":"#ececec","container":"download-app-banner__container__3zdXA","icon":"download-app-banner__icon__36Bwa","text":"download-app-banner__text__3_roy","app-name":"download-app-banner__app-name__3fymw","description":"download-app-banner__description__EaLaS","download-btn":"download-app-banner__download-btn__zC1Jt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/global/download-app-banner.scss
// module id = 1308
// module chunks = 1